class FunnelElement extends HTMLElement {
  constructor() {
    super();

    if (this.classList.contains('empty')) return;

    this.loading = false;
    this.step = 1;
    this.stepButtons = this.querySelectorAll('.funnel-step')
    this.nextButtons = this.querySelectorAll('.funnel-btn')
    this.form = this.querySelector('form.shopify-product-form')
    this.dateBlock = this.querySelector('.funnel-date-block')
    this.dateInput = this.querySelector('.funnel-date-block .funnel-input')
    this.addressesWrapper = this.querySelector('.funnel-addresses-wrapper')
    this.addressesSearch = this.querySelector('.funnel-addresses__search input')
    this.addressesTriggers = this.querySelectorAll('.funnel-addresses-trigger')
    this.addressesCategories = this.querySelector('.funnel-addresses__categories')
    this.addressesLists = this.querySelector('.funnel-addresses__lists')
    this.api = 'https://d4d-503de19ae2e0.herokuapp.com/addresses/'
    this.data = {
      search: {
        page: 1,
        end: false,
        fetch: false,
        loading: false,
        query: '',
      },
      celebs: {
        page: 1,
        fetch: true,
        end: false,
        loading: false,
        query: '',
      },
      politicians: {
        page: 1,
        fetch: true,
        end: false,
        loading: false,
        query: '',
      },
      unpopular: {
        page: 1,
        fetch: false,
        end: true,
        loading: false,
        query: '',
      }
    }
    this.mode = 'unpopular'

    const debouncedSearch = debounce(e => {
      this.handleSearch(e)
    }, 500)

    this.addressesSearch.addEventListener('input', debouncedSearch.bind(this))
    this.addressesSearch.addEventListener('search', debouncedSearch.bind(this))

    this.addressesLists.addEventListener('click', this.handleLists.bind(this))

    this.dateBlock.addEventListener('change', this.handleDate.bind(this))

    this.form.addEventListener('submit', this.handleSubmit.bind(this))

    this.addressesCategories.addEventListener('change', function (e) {
      this.handleCategory(e.target.value)
    }.bind(this))

    this.addressesTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', this.toggleWrapper.bind(this))
    }.bind(this))

    this.nextButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        this.changeStep(this.step + 1)
      }.bind(this))
    }.bind(this))

    this.stepButtons.forEach(function (button) {
      this.handleStepButton(button)
    }.bind(this))
  }

  getParams(form) {
    const params = []
    if (this.address) {
      const shipping = 'checkout[shipping_address]'
      const name = this.address.name.split(' ')
      const lastName = name.pop()
      const firstName = name.join(' ')

      params.push(`${shipping}[first_name]=${encodeURI(firstName)}`)
      params.push(`${shipping}[last_name]=${encodeURI(lastName)}`)
      params.push(`${shipping}[address1]=${encodeURI(this.address.line)}`)
      params.push(`${shipping}[address2]=${encodeURI(this.address?.line2 || '')}`)
      params.push(`${shipping}[city]=${encodeURI(this.address.city)}`)
      params.push(`${shipping}[province]=${encodeURI(this.address.state)}`)
      params.push(`${shipping}[zip]=${encodeURI(this.address.zip)}`)
      params.push(`${shipping}[country]=${encodeURI('United States')}`)
    }


    params.push(`attributes[sender_name]=${encodeURI(form["properties[SENDER'S NAME]"] || '')}`)
    params.push(`attributes[recipient_name]=${encodeURI(form["properties[RECIPIENT'S NAME]"] || '')}`)
    params.push(`attributes[recipient_address]=${encodeURI(form["properties[RECIPIENT'S ADDRESS]"] || '')}`)
    params.push(`attributes[message]=${encodeURI(form["properties[OPTIONAL MESSAGE]"] || '')}`)
    params.push(`attributes[medical_condition]=${encodeURI(form["properties[OPTIONAL GAG MEDICAL CONDITION]"] || '')}`)
    params.push(`attributes[delivery_date]=${encodeURI(form["properties[DELIVERY DATE]"] || '')}`)

    return params.join('&')
  }

  handleSubmit(e) {
    e.preventDefault();
    if (this.loading) return;

    this.loading = true
    const formData = objectifyForm(e.target)
    const params = this.getParams(formData)
    const url = `/cart/${formData.id}:1?${params}`

    location.href = url
  }

  toggleWrapper() {
    this.addressesWrapper.classList.toggle('active')
    document.body.classList.toggle('overflow-hidden')
  }

  handleDate(e) {
    const { target: { name, value } } = e
    if (name === 'delivery-option' && value === 'asap') this.dateInput.value = ''
  }

  handleStepButton(btn) {
    btn.addEventListener('click', function () {
      if (!btn.classList.contains('done') || btn.classList.contains('active')) return;
      this.changeStep(btn.dataset.step)
    }.bind(this))
  }

  changeStep(n) {
    this.step = Number(n);
    this.querySelector('.funnel-step.active').classList.remove('active')
    this.querySelector('.funnel-section.active').classList.remove('active')

    this.querySelector(`.funnel-step[data-step="${this.step}"]`).classList.add('done')
    this.querySelector(`.funnel-step[data-step="${this.step}"]`).classList.add('active')
    this.querySelector(`.funnel-section[data-step="${this.step}"]`).classList.add('active')
  }

  async fetchApi(path = '', render = true) {
    const mode = this.mode
    if (this.data[mode].loading) return;

    this.data[mode].loading = true

    const res = await fetch(this.api + path)
      .then(r => r.json())
      .catch(err => {
        alert('there has been an error')
        console.log(err)
      })

    this.data[mode].loading = false

    if (!render) return res;

    const wrapper = this.addressesWrapper.querySelector(`.funnel-addresses__list[data-category="${mode}"]`)

    const loadBtn = wrapper.querySelector('.load-addresses')
    if (loadBtn) loadBtn.remove()

    if (res.length === 0) {
      this.data[mode].end = true;
      return
    }

    if (this.data[mode].page === 1 && mode === 'search') wrapper.innerHTML = '';

    res.forEach(function (address) {
      const element = this.createAddress(address)
      wrapper.appendChild(element)
    }.bind(this))

    const newLoadBtn = document.createElement('button')
    newLoadBtn.type = 'button'
    newLoadBtn.className = 'load-addresses funnel-addresses-button'
    newLoadBtn.textContent = 'Load More'
    wrapper.appendChild(newLoadBtn)
  }

  createAddress(address) {
    const element = document.createElement('div')
    element.classList.add('funnel-address')
    element.innerHTML = `
      <span>${address.name}</span> 
      <button type="button" class="funnel-addresses-button" data-id="${address.id}">This Douche</button>
    `

    return element;
  }

  handleSearch(e) {
    const { target: { value } } = e;

    if (value === '') {
      this.addressesCategories.querySelector('input[value="unpopular"]').checked = true;
      this.handleCategory('unpopular')
      return
    }

    this.data.search.query = encodeURI(value);
    this.data.search.page = 1
    this.handleCategory('search')
    this.fetchApi(`?q=${this.data.search.query}`)
  }

  async handleCategory(value) {
    this.mode = value
    this.addressesWrapper.dataset.mode = value

    if (this.data[value].fetch) {
      this.data[value].fetch = false
      await this.fetchApi(value)
      return
    }
  }

  async handleLists(e) {
    e.stopPropagation()
    const id = e.target.dataset.id
    const loadMore = e.target.classList.contains('load-addresses')

    if (loadMore) {
      this.data[this.mode].page = this.data[this.mode].page + 1
      const path = this.mode === 'search' ? '' : this.mode
      this.fetchApi(`${path}?p=${this.data[this.mode].page}&q=${this.data[this.mode].query}`)
      return
    }

    if (!id) return;

    this.toggleWrapper()
    const data = await this.fetchApi(id, false)

    if (!data?.name) {
      return;
    }

    this.address = {
      name: data.name,
      line: data.line,
      line2: data.line2 || '',
      zip: data.zip,
      city: data.city,
      state: data.state,
    };
    const nameInput = this.querySelector(`.funnel-input[name="properties[RECIPIENT'S NAME]"]`)
    nameInput.value = data.name
    const addressInput = this.querySelector(`.funnel-input[name="properties[RECIPIENT'S ADDRESS]"]`)
    addressInput.value = [data.line, (data.line2 || ''), data.city, data.zip, data.state, 'United States'].join(', ')
  }
}

customElements.define('funnel-element', FunnelElement);
